const Spanish = {
    weekdays: {
        shorthand: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        longhand: [
            'Domingo',
            'Lunes',
            'Martes',
            'Miércoles',
            'Jueves',
            'Viernes',
            'Sábado',
        ],
    },
    months: {
        shorthand: [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Sep',
            'Oct',
            'Nov',
            'Dic',
        ],
        longhand: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],
    },
    ordinal: () => 'º',
    firstDayOfWeek: 1,
    rangeSeparator: ' a ',
    time24hr: true,
    timeLabel: 'Hora',
    okLabel: 'Ok',
};

export default Spanish;
export { Spanish };
//# sourceMappingURL=es.js.map
